import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/styles/style.css';
import './assets/styles/App.css';
import './assets/styles/service-cards.css';

// Some routes are prerendered to static HTML at build time (see
// scripts/prerender.mjs) so crawlers and AI tools can read the content
// without executing JavaScript. On the client we intentionally render
// (not hydrate) into that markup: the prerendered HTML gives an instant
// first paint, then React takes over with an identical render. Skipping
// hydration avoids React 18's strict text-node/attribute mismatch errors,
// which are fragile with serialized DOM captures.
const rootElement = document.getElementById('root');
createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
